import { useConfig } from "@agportal/config";
import Matomo from "vue-matomo";

export default function install(app) {
    const config = useConfig();
    const options = config.$get("matomo");

    if (options.enabled) {
        app.use(Matomo, options);

        // set to true to not track users who opt out of tracking using Mozilla's (proposed) Do Not Track setting
        window._paq.push(["setDoNotTrack", true]);
        window._paq.push(["trackPageView"]);
    }
}
